import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';
import { Subscription } from 'rxjs';

//components
import { HeaderComponent } from './shared/components/header/header.component';
import { FooterComponent } from './shared/components/footer/footer.component';

//material
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    HeaderComponent,
    FooterComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {

  //subscriptions
  private _versionUpdates$!: Subscription;

  constructor(
    private swUpdate: SwUpdate,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    if (this.swUpdate.isEnabled) {
      this.checkForUpdate();

      setInterval(() => {
        this.checkForUpdate();
      }, 300000);
    }
  }

  private checkForUpdate() {
    this.swUpdate.checkForUpdate().then(res => {
      if (res) {
        this.snackBar.open('A new version of the app is available', 'Update').onAction().subscribe(_ => {
          this.swUpdate.activateUpdate().then(() => document.location.reload());
        });
      }
    }).catch(err => {
      console.log(err);
    });
  }

  ngOnDestroy(): void {
    if (this._versionUpdates$) this._versionUpdates$.unsubscribe();
  }
}
